module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":{"upload":"Upload File","replace":"Replace File"},"introduction":["Are you sure you want to upload {filename} as {attachmentName}?","We are double-checking because the filenames do not match."]}}')
  delete Component.options._Ctor
}
